module.exports = __webpack_public_path__ + "static/media/distance.b104b596.svg";